type AtwProductMarkProps = {
  id: "agents";
  size?: number;
  className?: string;
  label?: boolean;
};

export function AtwProductMark({ size = 24, className = "", label }: AtwProductMarkProps) {
  return (
    <span className={`inline-flex items-center gap-2 ${className}`}>
      <img
        src="/images/agents/network.png"
        alt=""
        width={size}
        height={size}
        className="shrink-0"
        aria-hidden
      />
      {label ? <span className="sr-only">ATW Workforce</span> : null}
    </span>
  );
}

/** Drawn lockup, same family as Directory and One. The collapsed rail uses the network mark alone. */
export function AtwWorkforceLockup({ className = "h-14 w-auto" }: { className?: string }) {
  return (
    <img
      src="/images/agents/wordmark.png"
      alt="ATW Workforce"
      className={`object-contain object-center ${className}`}
      loading="eager"
      decoding="async"
    />
  );
}
